module.exports = __webpack_public_path__ + "static/media/03.60c1a1ce.mp3";